import { render, staticRenderFns } from "./ChipNomina.vue?vue&type=template&id=37e793e3&"
import script from "./ChipNomina.vue?vue&type=script&lang=js&"
export * from "./ChipNomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports